import { Divider } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React from 'react';
import LinkGroup, { LinkGroupProps } from '../LinkGroup/LinkGroup';
import { LinkAppearance } from '../LinkGroup/LinkGroup.constants';
import { SUBHEADER_ID, SubheaderType } from './SubHeader.constants';
import styles from './SubHeader.module.scss';

interface SubHeaderProps extends Pick<LinkGroupProps, 'routes' | 'onRouteClick'> {
  title: string;
  children?: React.ReactNode;
  type?: SubheaderType;
  showBottomBorder?: boolean;
}

const cx = classNames.bind(styles);

const SubHeader = ({
  title,
  routes,
  children,
  type = SubheaderType.Feed,
  onRouteClick,
  showBottomBorder,
}: SubHeaderProps): React.ReactElement => {
  return (
    <div className={cx('body', `body-${type}`, { 'show-border-bottom': showBottomBorder })} id={SUBHEADER_ID}>
      <div className={cx('section', `section-${type}`)}>
        <h2 className={cx('title')} data-testid="sub-header-title">
          {title}
        </h2>
        {!!routes.length && (
          <>
            <Divider vertical />
            <LinkGroup linkMode={LinkAppearance.Ghost} routes={routes} onRouteClick={onRouteClick} />
          </>
        )}
      </div>
      {children && <div className={cx('section', 'section-children')}>{children}</div>}
    </div>
  );
};

export default SubHeader;
